import { Center, Text } from "@mantine/core";

interface ReportEmptyStateProps {
  message: string;
}

export function ReportEmptyState({ message }: ReportEmptyStateProps) {
  return (
    <Center py="xl">
      <Text c="dimmed">{message}</Text>
    </Center>
  );
}
